import React,{Component} from 'react';  
import {Link} from 'react-router-dom';
import axios from 'axios';

export class Blogdata extends Component {
   
   constructor(props) {
      super(props)

      this.state = {
         insights:[]
      }
   }
   componentDidMount(){
      axios.get("https://www.intellisaving.com/insights.php",{
         method:'GET',
         headers:{
            'Accept':'application/json',
            'Content-Type':'application/json'
         }      
      })
      .then(response => {
         this.setState({
            insights:response.data
         })
      })
   }

   render() { 
      const insights = this.state.insights;   

      return (
         <div>
         <section className="section-pading pt-0">
            <div className="container">
               <div className="row">
                  <div className="col-sm-12 col-md-12">
                     <div className="block-page-title-block">
                        <h1 className="page-title">Money Saving Tips</h1>
                     </div>
                  </div>
               </div>
            </div> 
            <div className='container' >
               <div className="row">  
               {insights.map(item => {
                  return (
                  <div class="col-sm-12 col-md-4">
                     <div className="insightarea">
                        <img className="insightimg" src= {item['image_url']} alt="insight-img1"/>
                        <div className="insight-textarea">
                           <a href={item['slug']} className="insight-link" target="_blank">
                           <h3 className="insight-hding">{item['title']}</h3>
                           </a>
                           <a href={item['slug']} className="insight-link" target="_blank">Read More</a>
                        </div>
                     </div>
                     </div>
                  );
               })}
               </div>
            </div>  
         </section>
         </div>
      );
   
   }  
}  
        
export default Blogdata;